var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("br"),
              _c(
                "b-button",
                {
                  staticClass: "ml-1",
                  attrs: {
                    size: "sm",
                    variant: "outline-primary",
                    title: "Update Data",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onOpenNew()
                    },
                  },
                },
                [
                  _c("b-icon", { attrs: { icon: "plus" } }),
                  _c("span", [_vm._v("New")]),
                ],
                1
              ),
              _c("br"),
              _c("b-table", {
                style: { "font-size": "11px" },
                attrs: {
                  id: "tbl-plan-data",
                  fields: _vm.fields,
                  items: _vm.items,
                  responsive: "",
                  "sticky-header": true,
                  hover: "",
                  "per-page": _vm.pagination.limit,
                  "current-page": _vm.pagination.current,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(division_name)",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getDivisionName(row.item))),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(creation_date)",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              row.item.update_date || row.item.creation_date
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(creation_user)",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              row.item.update_user || row.item.creation_user
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(action)",
                    fn: function (row) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "outline-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.onEdit(row.item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("edit"),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "outline-primary", size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.onDelete(row.item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "my-modal-mvp",
          attrs: {
            id: "my-modal-mvp",
            size: _vm.is_add_detail ? "xl" : "md",
            title: "Demo",
            "hide-footer": "",
            "no-close-on-backdrop": true,
            "no-close-on-esc": true,
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _vm._v(_vm._s(_vm.new_item.id ? "Edit" : "Create") + " MVP"),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "b-col",
                  { class: _vm.isAddDetail },
                  [
                    _c(
                      "b-col",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-size": "sm",
                              label: "Description :",
                              "label-cols": "4",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: { size: "sm", disabled: _vm.readonly },
                              model: {
                                value: _vm.new_item.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.new_item, "description", $$v)
                                },
                                expression: "new_item.description",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-size": "sm",
                              label: "Type :",
                              "label-cols": "4",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: { size: "sm", disabled: _vm.readonly },
                              model: {
                                value: _vm.new_item.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.new_item, "type", $$v)
                                },
                                expression: "new_item.type",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-size": "sm",
                              label: "Priority :",
                              "label-cols": "4",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: { size: "sm", disabled: _vm.readonly },
                              model: {
                                value: _vm.new_item.priority,
                                callback: function ($$v) {
                                  _vm.$set(_vm.new_item, "priority", $$v)
                                },
                                expression: "new_item.priority",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-size": "sm",
                              label: "Deliverables :",
                              "label-cols": "4",
                            },
                          },
                          [
                            _c(
                              "b-list-group",
                              {
                                key: _vm.key_deliveries,
                                attrs: { size: "sm" },
                              },
                              [
                                _vm._l(
                                  _vm.new_item.deliverables,
                                  function (item, index) {
                                    return _c(
                                      "b-list-group-item",
                                      {
                                        key: index,
                                        staticClass: "p-2 form-control-sm",
                                        attrs: { size: "sm" },
                                      },
                                      [
                                        _c("span", [_vm._v(_vm._s(item.name))]),
                                        !_vm.readonly
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  cursor: "pointer",
                                                  position: "absolute",
                                                  right: "0",
                                                },
                                                attrs: { title: "Delete" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onDelDelivery(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                    staticStyle: {
                                                      color: "blue",
                                                      "font-size": "medium",
                                                    },
                                                  },
                                                  [_vm._v("delete")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                !_vm.readonly
                                  ? _c(
                                      "b-input-group",
                                      {
                                        staticClass: "mt-1",
                                        attrs: { size: "sm" },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            disabled: _vm.readonly,
                                          },
                                          model: {
                                            value: _vm.new_delivery.name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.new_delivery,
                                                "name",
                                                $$v
                                              )
                                            },
                                            expression: "new_delivery.name",
                                          },
                                        }),
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true },
                                              },
                                            ],
                                            staticClass:
                                              "p-1 btn-outline-primary",
                                            attrs: {
                                              size: "sm",
                                              title: "Add Deliverable",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onAddDelivery()
                                              },
                                            },
                                          },
                                          [
                                            _c("b-icon", {
                                              attrs: { icon: "plus" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-size": "sm",
                              label: "Duration :",
                              "label-cols": "4",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: { size: "sm", disabled: _vm.readonly },
                              model: {
                                value: _vm.new_item.duration,
                                callback: function ($$v) {
                                  _vm.$set(_vm.new_item, "duration", $$v)
                                },
                                expression: "new_item.duration",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-size": "sm",
                              label: "Cost :",
                              "label-cols": "4",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: { size: "sm", disabled: _vm.readonly },
                              model: {
                                value: _vm.new_item.cost,
                                callback: function ($$v) {
                                  _vm.$set(_vm.new_item, "cost", $$v)
                                },
                                expression: "new_item.cost",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-size": "sm",
                              label: "Logical Entities :",
                              "label-cols": "4",
                            },
                          },
                          [
                            _c(
                              "b-list-group",
                              { key: _vm.key_entities, attrs: { size: "sm" } },
                              _vm._l(_vm.entities, function (item, index) {
                                return _c(
                                  "b-list-group-item",
                                  {
                                    key: index,
                                    staticClass: "p-1 form-control-sm",
                                    attrs: { size: "sm" },
                                  },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          size: "sm",
                                          id: item.id,
                                          name: item.id,
                                          value: true,
                                          "unchecked-value": false,
                                        },
                                        model: {
                                          value: item.check,
                                          callback: function ($$v) {
                                            _vm.$set(item, "check", $$v)
                                          },
                                          expression: "item.check",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "10px",
                                              "margin-top": "2px",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-size": "sm",
                              label: "Strategic Plan :",
                              "label-cols": "4",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                disabled: _vm.readonly,
                                options: _vm.plan_pilares,
                                size: "sm",
                              },
                              model: {
                                value: _vm.new_item.plan_pilar_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.new_item, "plan_pilar_id", $$v)
                                },
                                expression: "new_item.plan_pilar_id",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-size": "sm",
                              label: "Details :",
                              "label-cols": "4",
                            },
                          },
                          [
                            _c(
                              "b-list-group",
                              { key: _vm.key_details, attrs: { size: "sm" } },
                              _vm._l(
                                _vm.new_item.details,
                                function (item, index) {
                                  return _c(
                                    "b-list-group-item",
                                    {
                                      key: index,
                                      staticClass: "p-2 form-control-sm",
                                      attrs: { size: "sm" },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(item.outcome)),
                                      ]),
                                      !_vm.readonly
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                cursor: "pointer",
                                                position: "absolute",
                                                right: "0",
                                              },
                                              attrs: { title: "Delete" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDelDetail(index)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    color: "blue",
                                                    "font-size": "medium",
                                                  },
                                                },
                                                [_vm._v("delete")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass: "p-1 btn-outline-primary",
                                attrs: { size: "sm", title: "Add Detail" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onIsAddDetail()
                                  },
                                },
                              },
                              [_c("b-icon", { attrs: { icon: "plus" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-size": "sm",
                              label: "Oportunity :",
                              "label-cols": "4",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                disabled: _vm.readonly,
                                options: _vm.oportunities,
                                size: "sm",
                              },
                              model: {
                                value: _vm.new_item.oportunity_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.new_item, "oportunity_id", $$v)
                                },
                                expression: "new_item.oportunity_id",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.new_item.industries
                      ? _c(
                          "b-col",
                          { staticClass: "col-12" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-size": "sm",
                                  label: "Industries :",
                                  "label-cols": "4",
                                },
                              },
                              [
                                _c(
                                  "b-list-group",
                                  {
                                    key: _vm.key_industries,
                                    attrs: { size: "sm" },
                                  },
                                  _vm._l(
                                    _vm.new_item.industries,
                                    function (item, index) {
                                      return _c(
                                        "b-list-group-item",
                                        {
                                          key: index,
                                          staticClass: "p-2 form-control-sm",
                                          attrs: { size: "sm" },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(item.name) +
                                                " / " +
                                                _vm._s(item.description) +
                                                " / " +
                                                _vm._s(item.percentage)
                                            ),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.is_add_detail
                  ? _c(
                      "b-col",
                      { class: _vm.isAddDetail },
                      [
                        _c(
                          "b-card",
                          [
                            _c("h6", [_vm._v("Create Mvp Detail")]),
                            _c(
                              "b-col",
                              { staticClass: "col-12" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      "label-size": "sm",
                                      label: "Outcome :",
                                      "label-cols": "4",
                                    },
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        size: "sm",
                                        disabled: _vm.readonly,
                                      },
                                      model: {
                                        value: _vm.new_detail.outcome,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.new_detail,
                                            "outcome",
                                            $$v
                                          )
                                        },
                                        expression: "new_detail.outcome",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { staticClass: "col-12" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      "label-size": "sm",
                                      label: "Critical Factors :",
                                      "label-cols": "4",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-list-group",
                                      {
                                        key: _vm.key_critical_factors,
                                        attrs: { size: "sm" },
                                      },
                                      [
                                        _vm._l(
                                          _vm.new_detail.critical_factors,
                                          function (item, index) {
                                            return _c(
                                              "b-list-group-item",
                                              {
                                                key: index,
                                                staticClass:
                                                  "p-2 form-control-sm",
                                                attrs: { size: "sm" },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(item)),
                                                ]),
                                                !_vm.readonly
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                          position: "absolute",
                                                          right: "0",
                                                        },
                                                        attrs: {
                                                          title: "Delete",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.onDelCriticalFactor(
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                            staticStyle: {
                                                              color: "blue",
                                                              "font-size":
                                                                "medium",
                                                            },
                                                          },
                                                          [_vm._v("delete")]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                        !_vm.readonly
                                          ? _c(
                                              "b-input-group",
                                              {
                                                staticClass: "mt-1",
                                                attrs: { size: "sm" },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    disabled: _vm.readonly,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.new_critical_factor,
                                                    callback: function ($$v) {
                                                      _vm.new_critical_factor =
                                                        $$v
                                                    },
                                                    expression:
                                                      "new_critical_factor",
                                                  },
                                                }),
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true,
                                                        },
                                                      },
                                                    ],
                                                    staticClass:
                                                      "p-1 btn-outline-primary",
                                                    attrs: {
                                                      size: "sm",
                                                      title:
                                                        "Add Critical Factor",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onAddCriticalFactor()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("b-icon", {
                                                      attrs: { icon: "plus" },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { staticClass: "col-12" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      "label-size": "sm",
                                      label: "Macro Definition :",
                                      "label-cols": "4",
                                    },
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        size: "sm",
                                        disabled: _vm.readonly,
                                      },
                                      model: {
                                        value: _vm.new_detail.macro_definition,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.new_detail,
                                            "macro_definition",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "new_detail.macro_definition",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { staticClass: "col-12" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      "label-size": "sm",
                                      label: "Utility :",
                                      "label-cols": "4",
                                    },
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        size: "sm",
                                        disabled: _vm.readonly,
                                      },
                                      model: {
                                        value: _vm.new_detail.utility,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.new_detail,
                                            "utility",
                                            $$v
                                          )
                                        },
                                        expression: "new_detail.utility",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { staticClass: "col-12" },
                              [
                                _c("b-form-group", {
                                  attrs: {
                                    "label-size": "sm",
                                    label: "OKRs :",
                                    "label-cols": "4",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { staticClass: "col-12" },
                              [
                                _c("b-form-group", {
                                  attrs: {
                                    "label-size": "sm",
                                    label: "KPIs :",
                                    "label-cols": "4",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { staticClass: "col-12" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      "label-size": "sm",
                                      label: "Used Resources :",
                                      "label-cols": "4",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-list-group",
                                      {
                                        key: _vm.key_used_resources,
                                        attrs: { size: "sm" },
                                      },
                                      [
                                        _vm._l(
                                          _vm.new_detail.used_resources,
                                          function (item, index) {
                                            return _c(
                                              "b-list-group-item",
                                              {
                                                key: index,
                                                staticClass:
                                                  "p-2 form-control-sm",
                                                attrs: { size: "sm" },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.description) +
                                                      " - " +
                                                      _vm._s(item.total)
                                                  ),
                                                ]),
                                                !_vm.readonly
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                          position: "absolute",
                                                          right: "0",
                                                        },
                                                        attrs: {
                                                          title: "Delete",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.onDelUserResource(
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                            staticStyle: {
                                                              color: "blue",
                                                              "font-size":
                                                                "medium",
                                                            },
                                                          },
                                                          [_vm._v("delete")]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                        !_vm.readonly
                                          ? _c(
                                              "b-input-group",
                                              {
                                                staticClass: "mt-1",
                                                attrs: { size: "sm" },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    disabled: _vm.readonly,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.new_used_resource
                                                        .description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.new_used_resource,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "new_used_resource.description",
                                                  },
                                                }),
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    disabled: _vm.readonly,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.new_used_resource
                                                        .total,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.new_used_resource,
                                                        "total",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "new_used_resource.total",
                                                  },
                                                }),
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true,
                                                        },
                                                      },
                                                    ],
                                                    staticClass:
                                                      "p-1 btn-outline-primary",
                                                    attrs: {
                                                      size: "sm",
                                                      title:
                                                        "Add Used Resource",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onAddUsedResource()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("b-icon", {
                                                      attrs: { icon: "plus" },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { staticClass: "col-12 text-right" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "ml-2",
                                    attrs: { size: "sm" },
                                    on: { click: _vm.onCancelAddDetail },
                                  },
                                  [
                                    _c(
                                      "i",
                                      { staticClass: "material-icons md-16" },
                                      [_vm._v("cancel")]
                                    ),
                                    _c("span", [_vm._v("Close")]),
                                  ]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "active ml-2 outline-primary",
                                    attrs: {
                                      size: "sm",
                                      variant: "outline-primary",
                                    },
                                    on: { click: _vm.onAddDetail },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("send"),
                                    ]),
                                    _vm._v(
                                      _vm._s(_vm.$t("botones.boton_aceptar"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { sm: "12", lg: "12" } }, [
                _c("div", { staticClass: "mt-3 row" }, [
                  _c(
                    "div",
                    { staticClass: "float-rigth col-12" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2",
                          attrs: { size: "sm" },
                          on: { click: _vm.onCancel },
                        },
                        [
                          _c("i", { staticClass: "material-icons md-16" }, [
                            _vm._v("cancel"),
                          ]),
                          _c("span", [_vm._v("Cancel")]),
                        ]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "active ml-2",
                          attrs: { size: "sm", variant: "primary" },
                          on: { click: _vm.onSaveMvp },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("send"),
                          ]),
                          _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }